//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepertoireDisplayItem } from './RepertoireDisplayItem';

export class CalendarRepertoireDisplayItem extends ItemBase {
    Repertoire: RepertoireDisplayItem | null = null;
    StudentFirstName: string | null = null;
    StudentFullName: string | null = null;
    StudentID: string | null = null;
    StudentLastName: string | null = null;

    constructor(initializer?: Partial<CalendarRepertoireDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarRepertoireDisplayItem";
}
